import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { useI18n } from "../../lib/i18n/i18n_provider";

import { OfferingDetailsDayPass } from "../template_offering_details_daypass";
import { useBrainEmbassyAnalytics } from "./brain-embassy_analytics";
import {
  dayPassFaqsEN,
  dayPassFaqsPL,
  generalInfoEN,
  generalInfoPL,
  partnerConfig,
  testimonials,
} from "./brain-embassy_partner_config";

const Theme = lazyWithRetry(() => import("./brain-embassy_theme"));

export function OfferingBrainEmbassyDayPass() {
  useBrainEmbassyAnalytics();
  const { locale } = useI18n();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          testimonials: testimonials,
          faqs: locale.baseLanguageTag === "pl" ? dayPassFaqsPL : dayPassFaqsEN,
          generalInfo:
            locale.baseLanguageTag === "pl" ? generalInfoPL : generalInfoEN,
          title:
            locale.baseLanguageTag === "pl"
              ? "Jednodniowy dostęp do przestrzeni"
              : "Day Pass",
        }}
      />
    </Fragment>
  );
}
